import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CompareByOption } from 'components/Segmentation/CompareBy'
import { OptionTypeBase } from 'react-select/src/types'

export interface AppliedCompareBy {
  compareById: string
  activeRadio: CompareByOption
  appliedComparators: OptionTypeBase[]
  isOtherUnclassifiedPresent?: boolean
}

const initialState: AppliedCompareBy[] = []

const compareBySlice = createSlice({
  name: 'appliedCompareBy',
  initialState,
  reducers: {
    setAppliedCompareBy(state, action: PayloadAction<AppliedCompareBy>) {
      return state
        .filter(({ compareById }) => compareById !== action.payload.compareById)
        .concat(action.payload)
    },
    setAllAppliedCompareBy(state, action: PayloadAction<AppliedCompareBy[]>) {
      return action.payload ?? initialState
    },
  },
})
export const { setAppliedCompareBy, setAllAppliedCompareBy } = compareBySlice.actions
export default compareBySlice.reducer
